export var NSSpecies;
(function (NSSpecies) {
    var _a, _b, _c, _d, _e;
    var TStability;
    (function (TStability) {
        TStability["Dried"] = "dried";
        TStability["Fresh"] = "fresh";
        TStability["Frozen"] = "frozen";
    })(TStability = NSSpecies.TStability || (NSSpecies.TStability = {}));
    var TKelpFormat;
    (function (TKelpFormat) {
        TKelpFormat["Whole"] = "whole";
        TKelpFormat["Blade"] = "blade";
        TKelpFormat["Stipe"] = "stipe";
        TKelpFormat["Ground"] = "ground";
        TKelpFormat["Powdered"] = "powdered";
    })(TKelpFormat = NSSpecies.TKelpFormat || (NSSpecies.TKelpFormat = {}));
    var TSpeciesKind;
    (function (TSpeciesKind) {
        TSpeciesKind["Kelp"] = "kelpSpecies";
        TSpeciesKind["Shellfish"] = "shellfishSpecies";
        TSpeciesKind["Other"] = "otherSpecies";
    })(TSpeciesKind = NSSpecies.TSpeciesKind || (NSSpecies.TSpeciesKind = {}));
    var TKelpSpecies;
    (function (TKelpSpecies) {
        TKelpSpecies["SugarKelp"] = "sugar_kelp";
        TKelpSpecies["Alaria"] = "alaria";
        TKelpSpecies["GiantKelp"] = "giant_kelp";
        TKelpSpecies["BullKelp"] = "bull_kelp";
    })(TKelpSpecies = NSSpecies.TKelpSpecies || (NSSpecies.TKelpSpecies = {}));
    var TShellfishSpecies;
    (function (TShellfishSpecies) {
        TShellfishSpecies["Mussels"] = "mussels";
        TShellfishSpecies["Clams"] = "clams";
        TShellfishSpecies["Oysters"] = "oysters";
        TShellfishSpecies["Scallops"] = "scallops";
    })(TShellfishSpecies = NSSpecies.TShellfishSpecies || (NSSpecies.TShellfishSpecies = {}));
    var kelpSpeciesLabels = (_a = {},
        _a[TKelpSpecies.SugarKelp] = {
            name: "Sugar Kelp",
            scientificName: "Saccharina latissima",
        },
        _a[TKelpSpecies.GiantKelp] = {
            name: "Giant Kelp",
            scientificName: "Macrocystis pyrifera",
        },
        _a[TKelpSpecies.Alaria] = {
            name: "Alaria",
            scientificName: "Alaria spp.",
        },
        _a[TKelpSpecies.BullKelp] = {
            name: "Bull Kelp",
            scientificName: "Nereocystis luetkeana",
        },
        _a);
    var shellfishSpeciesLabels = (_b = {},
        _b[TShellfishSpecies.Mussels] = { name: "Mussels" },
        _b[TShellfishSpecies.Clams] = { name: "Clams" },
        _b[TShellfishSpecies.Oysters] = { name: "Oysters" },
        _b[TShellfishSpecies.Scallops] = { name: "Scallops" },
        _b);
    var speciesKindLabels = (_c = {},
        _c[TSpeciesKind.Kelp] = "Kelp",
        _c[TSpeciesKind.Shellfish] = "Shellfish",
        _c[TSpeciesKind.Other] = "Other",
        _c);
    var formatLabels = (_d = {},
        _d[TKelpFormat.Blade] = "Blade Only",
        _d[TKelpFormat.Stipe] = "Stipe Only",
        _d[TKelpFormat.Whole] = "Whole Kelp",
        _d[TKelpFormat.Ground] = "Ground Kelp",
        _d[TKelpFormat.Powdered] = "Powdered Kelp",
        _d);
    var stabilityLabels = (_e = {},
        _e[TStability.Dried] = "Dried",
        _e[TStability.Fresh] = "Fresh",
        _e[TStability.Frozen] = "Frozen",
        _e);
    NSSpecies.labels = {
        speciesKind: speciesKindLabels,
        speciesLabels: {
            kelp: kelpSpeciesLabels,
            shellfish: shellfishSpeciesLabels,
        },
        formatLabels: formatLabels,
        stabilityLabels: stabilityLabels,
    };
})(NSSpecies || (NSSpecies = {}));
//# sourceMappingURL=species.js.map